import { useEffect } from "react";
import { cn } from "@/lib/cn";

interface ToastProps {
  open: boolean;
  message: string | null;
  onDismiss: () => void;
  durationMs?: number;
  variant?: "error" | "info";
}

export function Toast({
  open,
  message,
  onDismiss,
  durationMs = 5000,
  variant = "error",
}: ToastProps) {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(onDismiss, durationMs);
    return () => clearTimeout(timer);
  }, [open, durationMs, onDismiss]);

  if (!open || !message) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={cn(
        "fixed bottom-[18px] right-[18px] z-40 max-w-[360px] rounded-[12px] px-3 py-[10px] text-[13px] text-white shadow-lg",
        variant === "error" ? "bg-[var(--danger)]" : "bg-[var(--accent)]",
      )}
    >
      {variant === "error" ? `Error: ${message}` : message}
    </div>
  );
}
